import { ArrowDropDown, ArrowDropUp, StarOutline } from '@material-ui/icons';
import { Rating } from '@material-ui/lab';
import { isObject, isNumber } from 'lodash';
import { useState } from 'react';
import RatingView from './RatingView';

export default function BookingQuestionCard({
  bookingQuestion,
  ratingTemplate,
  index,
}) {
  const [solutionToggle, setSolutionToggle] = useState(false);
  return (
    <div className='bg-white rounded p-4 my-2'>
      <div className='flex font-medium gap-2'>
        <span>Q{index + 1}.</span>
        <pre>
          <span className='whitespace-pre-wrap'>
            {bookingQuestion.Question.question}
          </span>
        </pre>

        {/* Solution toggle */}
        <span
          onClick={() => setSolutionToggle(!solutionToggle)}
          className='text-sm font-normal opacity-60 cursor-pointer w-28'
        >
          Solution {solutionToggle ? <ArrowDropUp /> : <ArrowDropDown />}
        </span>
      </div>

      {/* Solution */}
      {solutionToggle && (
        <pre>
          <code>
            <p className='text-sm opacity-80 my-4 ml-8'>
              {bookingQuestion.Question.solution}
            </p>
          </code>
        </pre>
      )}

      {/* tags */}
      <div className='text-xs opacity-60 capitalize mt-2 ml-8'>
        <span>
          Difficulty Level :{' '}
          <span className='font-semibold capitalize'>
            {bookingQuestion.Question.difficultyLevel || '--'}
          </span>
        </span>
      </div>

      {/* Question Ratings */}
      <div className='mt-4'>
        <div className='flex items-center opacity-60 font-medium px-8 mb-1'>
          <span className='w-1/2' />
          <span className='w-1/4'>Coach Ratings</span>
          <span className='w-1/4'>Candidate Ratings</span>
        </div>
        {ratingTemplate?.parameters?.map((param) => {
          const name = param.name || param;
          return (
            <div
              className='flex items-center py-1.5 px-8 capitalize rounded hover:bg-ab-primary dark:hover:bg-white hover:bg-opacity-10 dark:hover:bg-opacity-10'
              key={name}
            >
              <span className='w-1/2 opacity-60'>{name}</span>
              {isObject(bookingQuestion.ratingFromCoach?.[name]) ? (
                <RatingView
                  parameter={name}
                  rating={bookingQuestion.ratingFromCoach?.[name]}
                  className='w-1/4'
                />
              ) : isNumber(bookingQuestion.ratingFromCoach?.[name]) ? (
                <Rating
                  value={bookingQuestion.ratingFromCoach?.[name]}
                  emptyIcon={
                    <StarOutline color='inherit' className='opacity-60' />
                  }
                  className='w-1/4'
                  readOnly
                />
              ) : (
                <span className='w-1/4'>-</span>
              )}
              {isObject(bookingQuestion.ratingFromStudent?.[name]) ? (
                <RatingView
                  parameter={name}
                  rating={bookingQuestion.ratingFromStudent?.[name]}
                  className='w-1/4'
                />
              ) : isNumber(bookingQuestion.ratingFromCoach?.[name]) ? (
                <Rating
                  value={bookingQuestion.ratingFromStudent?.[name]}
                  emptyIcon={
                    <StarOutline color='inherit' className='opacity-60' />
                  }
                  className='w-1/4'
                  readOnly
                />
              ) : (
                <span className='w-1/4'>-</span>
              )}
            </div>
          );
        })}

        {/* Question Feedback */}
        {ratingTemplate?.feedback && (
          <div className='mt-6 px-8'>
            <div className='font-medium text-sm mb-2'>Feedback</div>
            <p className='opacity-80'>
              {bookingQuestion.ratingFromCoach?.feedback || '--'}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
